import React, { useEffect, useState } from 'react';

import { normalizeTypes } from '../utils/search-filters';

export default function SearchTypesToggle({
  types,
  onChange,
}: {
  types: Array<string | { id: string }>;
  onChange: (types: string[]) => void;
}) {
  const [hostsEnabled, setHostsEnabled] = useState(
    normalizeTypes(types).includes('host'),
  );

  useEffect(() => {
    setHostsEnabled(normalizeTypes(types).includes('host'));
  }, [types]);

  return (
    <ul className="list-unstyled">
      <li className="form-group">
        <label className="tr-switch tr-switch-side-left">
          <input
            checked={hostsEnabled}
            onChange={() => {
              const nextTypes = hostsEnabled ? ['meet'] : ['host', 'meet'];
              setHostsEnabled(!hostsEnabled);
              onChange(nextTypes);
            }}
            type="checkbox"
          />
          <div className="toggle"></div>
          Hosts
        </label>
      </li>
    </ul>
  );
}
